export const formatBody = (text) => {
    if (!text) return '';
    const parts = text.split(/(\*[^*]+\*)/g);
    return parts.map((part, index) => {
        if (part.startsWith('*') && part.endsWith('*')) {
            return <strong key={index}>{part.slice(1, -1)}</strong>;
        }
        return part;
    });
};

export const formatWhatsappPhone = (phone) => {
    return phone ? phone.replace('whatsapp:', '') : '';
};

export const getPreviewBody = (bodyText, variableValues) => {
    if (!bodyText) return '';
    let preview = bodyText;
    const matches = bodyText.match(/\{\{([^}]+)\}\}/g) || [];
    matches.forEach(match => {
        const key = match.replace('{{', '').replace('}}', '');
        const val = variableValues[key] !== undefined && variableValues[key] !== '' ? variableValues[key] : `{{${key}}}`;
        const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
        preview = preview.replace(regex, val);
    });
    return preview;
};

export const getVariablesFromBody = (body) => {
    if (!body) return [];
    const matches = body.match(/\{\{([^}]+)\}\}/g) || [];
    const keys = matches.map(m => m.replace('{{', '').replace('}}', ''));
    return [...new Set(keys)].sort((a, b) => Number(a) - Number(b));
};